import { render, staticRenderFns } from "./ForbiddenView.vue?vue&type=template&id=43f9516a"
import script from "./ForbiddenView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForbiddenView.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports